/* ラストホビー（2026-09-29 追加）
   商品一覧・検索結果で、そのページに表示された売り切れ商品を後ろへ回す。
   Shopify標準の並び替えには「売り切れを最後に」が無いため、表示中のページ内で並べ替える。
   絞り込み・ページ送りで一覧が差し替わっても再実行する。 */
(function () {
  var GRID = '.Collection-wrapper, .search-results-wrapper .grid, #MainContent .grid--uniform';
  function sortGrid(grid) {
    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList.contains('grid__item');
    });
    var sold = items.filter(function (el) { return el.querySelector('.item--sold-out'); });
    if (!sold.length || sold.length === items.length) return;
    // 既に後ろに揃っていれば何もしない（無限ループ防止）
    var tail = items.slice(items.length - sold.length);
    if (tail.every(function (el) { return el.querySelector('.item--sold-out'); })) return;
    var anchor = items[items.length - 1].nextSibling;
    sold.forEach(function (el) { grid.insertBefore(el, anchor); });
  }
  function run() {
    document.querySelectorAll(GRID).forEach(sortGrid);
  }
  function start() {
    if (!/^\/(collections|search)/.test(location.pathname)) return;
    run();
    var main = document.getElementById('MainContent');
    if (!main || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
      .observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
